import { confirmable, ContextAwareConfirmation } from "react-confirm";
import GenericModal from "../components/layouts/GenericModal";
import { GenericFormModal } from "../components/layouts/GenericForm";

export const openModal = (options: any) => {
  return ContextAwareConfirmation.createConfirmation(confirmable(GenericModal))(
    options,
  );
};

export const openModalForm = (options: any) => {
  return openModal({
    ...options,
    body: <GenericFormModal options={options} />,
    hideActions: true,
  });
};
